<section id="mantenimiento" class="d-flex flex-column vh-100">
  <div class="container-fluid flex-grow-1 d-flex flex-column">
    <div class="row flex-grow-1">
      <div class="col-md-7 offset-md-5 d-flex flex-column my-auto text-center ">
        <img src="/assets/images/mantenimiento/logo.png" alt="Sorteo Egresados Anahuac" class="img-fluid mb-4 d-block mx-auto" width="360" />
        <p>Nos encontramos en </p>
        <h1>periodo de mantenimiento</h1>
      </div>
    </div>
  </div>
</section>
